import './App.css';
import Nav from './sections/Nav';
import Hero from './sections/Hero';
import Features from './sections/Features';
import Partner from './sections/Partner';
import Review from './sections/Review';
import Footer from './sections/Footer';

function App() {
  return (
    <>
      <Nav />
      <Hero />
      <Features />
      <Partner />
      <Review />
      <Footer />
    </>
  );
}

export default App;

